import { useState } from 'react';
import { REGION_LIST } from '@seedgovernance/shared';
import { Button } from '../../components/ui/Button';

interface RegionConfirmProps {
  selectedRegion: string;
  onNext: (regionId: string) => void;
  onBack: () => void;
}

export function RegionConfirm({ selectedRegion, onNext, onBack }: RegionConfirmProps) {
  const [region, setRegion] = useState(selectedRegion || '');
  const [confirmed, setConfirmed] = useState(false);

  return (
    <div className="max-w-md mx-auto">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-display font-bold text-white mb-2">
          Choose Your Data Region
        </h1>
        <p className="text-slate-400">
          All your data will be stored in this region for compliance. This cannot be changed later.
        </p>
      </div>

      <div className="space-y-3 mb-6">
        {REGION_LIST.map((r) => (
          <button
            key={r.id}
            onClick={() => { setRegion(r.id); setConfirmed(false); }}
            className={`w-full text-start p-4 rounded-xl border transition-colors ${
              region === r.id
                ? 'border-brand bg-brand/5'
                : 'border-border bg-surface-mid hover:border-slate-600'
            }`}
          >
            <p className="text-white font-semibold">{r.label}</p>
            <p className="text-slate-400 text-sm mt-1">
              Azure region: {r.azureRegion}
            </p>
          </button>
        ))}
      </div>

      {region && (
        <label className="flex items-start gap-3 p-4 rounded-lg bg-yellow-500/5 border border-yellow-500/20 mb-6 cursor-pointer">
          <input
            type="checkbox"
            checked={confirmed}
            onChange={(e) => setConfirmed(e.target.checked)}
            className="mt-0.5 accent-brand"
          />
          <span className="text-sm text-yellow-200">
            I understand that my data region cannot be changed after setup. All tenant data, files, and compliance documents will be stored in the selected region.
          </span>
        </label>
      )}

      <div className="flex gap-3">
        <Button variant="secondary" onClick={onBack} className="flex-1">
          Back
        </Button>
        <Button
          className="flex-1"
          disabled={!region || !confirmed}
          onClick={() => onNext(region)}
        >
          Confirm Region
        </Button>
      </div>
    </div>
  );
}
